module.exports = __webpack_public_path__ + "img/logo-footer.3f252a0c.svg";